/**
 * Small flag + ISO chip shown on story / article cards to surface the
 * publisher's origin country (sovereign-CERT v1).
 *
 * Renders nothing when `country` is null/undefined so callers can pass the
 * raw field straight through without a guard.
 */
const COUNTRY_FLAGS: Record<string, string> = {
  US: '\u{1F1FA}\u{1F1F8}',
  GB: '\u{1F1EC}\u{1F1E7}',
  AU: '\u{1F1E6}\u{1F1FA}',
  EU: '\u{1F1EA}\u{1F1FA}',
  IN: '\u{1F1EE}\u{1F1F3}',
  IE: '\u{1F1EE}\u{1F1EA}',
  NZ: '\u{1F1F3}\u{1F1FF}',
  SG: '\u{1F1F8}\u{1F1EC}',
};

const FALLBACK_FLAG = '\u{1F3F3}\u{FE0F}';

export function CountryBadge({ country }: { country: string | null | undefined }) {
  if (!country) return null;
  const flag = COUNTRY_FLAGS[country] ?? FALLBACK_FLAG;
  return (
    <span
      className="inline-flex items-center gap-1 rounded bg-muted/40 px-1.5 py-0.5 text-[10px] font-medium tabular-nums"
      title={`Origin: ${country}`}
    >
      <span aria-hidden="true">{flag}</span>
      <span>{country}</span>
    </span>
  );
}
